import { Component } from '@angular/core';
declare let $: any;
import * as Aos from 'aos';
import Swal from 'sweetalert2';
import { Buffer } from 'buffer';
// declare let Swiper: any;
// declare let bootstrap: any;
import { fciWebsiteService } from './headquarter/service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { EncryptDecryptService } from './headquarter/service/encrypt-decrypt.service';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
//FOR LANGUAGE CONVERSION - STARTS (FOR TOGGLING LANGUAGE CONVERSION)
import { TranslateService } from '@ngx-translate/core';
import { CustomServiceService } from './headquarter/service/custom-service.service';
//FOR LANGUAGE CONVERSION - ENDS
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'fci-website';
  visito_no:number=0;
  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService,private encDec: EncryptDecryptService, public translate: TranslateService) { }

  ngOnInit(): void {
    this.setMenudata();
    this.getZoneRegionName();// for get all zone and region list
    this.setImportantLink();
    if(!this.httpservice.checkcookies('fci_visitor')){
      this.setVisitorCounter(true);//add one
     }else {
      this.setVisitorCounter(false);//no need to update
      // console.log('old visitor');
     }       
  }

  setImportantLink(){
    this.fciwebservice.setImportantLinkData(
      {
        'total':0,
        'progress':true,
        'data':[],
        'respons':""
      }
    );
    let query:any = [
      {"columnName":"bitDeletedFlag","operator":"=","value":0,"joinoperator":"and"},
      {"columnName":"tinPublishStatus","operator":"=","value":1,"joinoperator":"and"}
      ]
      if(environment.ZONE_ID > 0){
        query.push({ "columnName": "ZONE_ID", "operator": "=", "value": environment.ZONE_ID, "joinoperator": "and" });
       }
    let params = [{
      "secSlNo":1,
        "offSet":0,
        "noOfRecords":'',
        "orderBy":[{"columnName":"intId","type":"DESC"}],
        "condition":query,
        "viewParameters":""
    }];
    this.fciwebservice.getAllImpLinks(params).subscribe((response: HttpEvent<any>):any => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          let bodydata:any = response.body;
          let respData:any = bodydata.RESPONSE_DATA;
          let respToken:any = bodydata.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response.toString());
            if (response.status == 200) {
              this.fciwebservice.setImportantLinkData(
                {
                  'total':response.result["sec_1"].length,
                  'progress':false,
                  'data':response.result["sec_1"],
                  'respons':response
                });
              return true;
            }
            this.fciwebservice.setImportantLinkData({
              'total':0,
              'progress':false,
              'data':[],
              'respons':response
            });
            return false;
          }
      }
    });
  }

  setMenudata():any { 
    if(window.sessionStorage.getItem('fcimenudata')){
      let localmenudata:any = window.sessionStorage.getItem('fcimenudata');
      localmenudata = JSON.parse(localmenudata);
      if(!localmenudata.progress){// data already exists in sessionstorage
        return true;
        // if(localmenudata.total > 0){
        //   return true;
        // }
      }
      // return true;
    }
    let query: any = [ 
      { "columnName": "INTGLOBALTYPE", "operator": "in", "value": '1,2', "joinoperator": "and" },
      // { "columnName": "VCHMENUTYPE", "operator": "=", "value": '1', "joinoperator": "and" },
      { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
      { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
    ]
    if (environment.ZONE_ID > 0) {
      query.push({ "columnName": "ZONE_ID", "operator": "=", "value": environment.ZONE_ID, "joinoperator": "and" });
    }
    let params = [{
      "secSlNo": 1,
      "offSet": 0,
      "noOfRecords": 0,
      "orderBy": [{ "columnName": "INTGLOBALTYPE", "type": "ASC" }, { "columnName": "INTSLNO", "type": "ASC" },],
      "condition": query,
      "viewParameters": ""
    }];
    this.fciwebservice.getAllMenuList(params, "ManageMenu").subscribe((resp: any):any => {
      let respData = resp.RESPONSE_DATA;
      let respToken = resp.RESPONSE_TOKEN;
      let verifyToken = CryptoJS.HmacSHA256(
        respData,
        environment.apiHashingKey
      ).toString();
      if (respToken == verifyToken) {
        let response: any = Buffer.from(respData, 'base64');
        response = JSON.parse(response.toString());
        if (response.status == 200) {
          this.fciwebservice.setMenuData({
            'total':response.result["sec_1"].length,
            'progress':false,
            'data':response.result["sec_1"],
            'respons':response
          });
          return true;
        }
      }
    })
  }
  update_time:any='00:00:00'; 
  lastUpdatedata:any = {
    "intId": '',
    "total_count": 0,
    "dtmCreatedOn": "2023-08-10 00:00:00",
    "stmUpdatedOn": "2023-08-17 00:00:00"
  };
    setVisitorCounter(type:boolean){
    var date = new Date();
    let data = JSON.stringify({"date": date.toUTCString()});
    document.cookie = "fci_visitor=" + data + "; path=/";
    this.fciwebservice.setVisitorCounterData(
      {
        'total':0,
        'progress':true,
        'data':[],
        'respons':'',
        'visito_no':0,
        'lastUpdatedata':'',
        'update_time' : '',
      }
    );
    
    this.httpservice.VisitorCounter({'type':type}).subscribe((response: HttpEvent<any>):any => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          let bodydata:any = response.body;
          let respData:any = bodydata.RESPONSE_DATA;
          let respToken:any = bodydata.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response.toString());
            if (response.original.status) {
              this.fciwebservice.setVisitorCounterData(
                {
                  'total':0,
                  'progress':false,
                  'data':response.original.data,
                  'respons':'',
                  'visito_no':response.original.data.total_count,
                  'lastUpdatedata':response.original.data,
                  'update_time' : response.original.update_time,
                });
              return true;
            }
            this.fciwebservice.setVisitorCounterData({ 
              'total':0,
              'progress':false,
              'data':[],
              'respons':'',
              'visito_no':0,
              'lastUpdatedata':'',
              'update_time' : '',
            });
            return false;
          }
      }
    });
  }



  content_apiresponse: any;
  zoneRegionList: any;
  getZoneRegionName() {// for get all zone and region list
    this.fciwebservice.getExploremenu().subscribe((response: any) => {
      this.zoneRegionList = response;
      this.fciwebservice.setZoneRegionNameData({
        'total':response.length,
        'progress':false,
        'data':response,
        'respons':response
      });
    });
    // var query: any = [];
    // query = [{ "columnName": "bit_Deleted_Flag", "operator": "=", "value": 0, "joinoperator": "and" },
    // { "columnName": "tin_Publish_Status", "operator": "=", "value": 1, "joinoperator": "and" }]
    // let params = [

    //   {
    //     "secSlNo": 1,
    //     "offSet": 0,
    //     "noOfRecords": '',
    //     "orderBy": '',
    //     "condition": query,
    //     "viewParameters": '',
    //   }];
    // this.fciwebservice.getZoneRegionName(params).subscribe((response: HttpEvent<any>) => {
    //   switch (response.type) {
    //     case HttpEventType.Sent:
    //       //console.log('Sent' + HttpEventType.Sent);
    //       break;
    //     case HttpEventType.ResponseHeader:
    //       //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
    //       break;
    //     case HttpEventType.UploadProgress:
    //       //this.evenTotal = response.total;
    //       //this.progress = Math.round(response.loaded / this.evenTotal * 100);
    //       break;
    //     case HttpEventType.Response:
    //       this.content_apiresponse = response.body;
    //       let respData = this.content_apiresponse.RESPONSE_DATA;
    //       let respToken = this.content_apiresponse.RESPONSE_TOKEN;
    //       let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
    //       if (respToken == verifyToken) {
    //         let response: any = Buffer.from(respData, 'base64');
    //         response = JSON.parse(response);
    //         this.zoneRegionList = response.result;
    //         this.fciwebservice.setZoneRegionNameData({
    //           'total':response.result.length,
    //           'progress':false,
    //           'data':response.result,
    //           'respons':response
    //         });
    //         // console.log(this.zoneRegionList);
    //       }
    //   }
    // });
  }







}